import { useEffect, useState } from "react";

// Returns TRUE while a text field (INPUT / TEXTAREA / contenteditable) is focused — a
// reliable, cross-browser proxy for "the on-screen keyboard is (or is about to be) open".
//
// Why focus and not viewport math: detecting the keyboard via `window.innerHeight` vs
// `visualViewport.height` is UNRELIABLE — Android Chrome's default
// `interactive-widget=resizes-content` shrinks BOTH together so the delta stays 0 (and the
// same is true in the Playwright test harness). Focus is the signal that actually holds
// everywhere. See the 2026-06 lot-notes tablet bug for the full story.
export function useSoftKeyboardOpen() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const isField = (el) => !!el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.isContentEditable);
    const sync = () => setOpen(isField(document.activeElement));
    document.addEventListener("focusin", sync);
    document.addEventListener("focusout", sync);
    sync();
    return () => {
      document.removeEventListener("focusin", sync);
      document.removeEventListener("focusout", sync);
    };
  }, []);
  return open;
}
